import { Component, Inject, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { ToastrService } from 'ngx-toastr';
import { MyErrorStateMatcher } from 'src/app/auth/login/login.component';
import { Contract } from 'src/app/contract/shared/contract.model';
import { ContractService } from 'src/app/contract/shared/contract.service';
import { Approver } from 'src/app/shared/approver.model';
import { Reviewer } from 'src/app/shared/reviewer.model';
import { UserService } from 'src/app/shared/user.service';

@Component({
  selector: 'app-add-team-dialog',
  templateUrl: './add-team-dialog.component.html',
  styleUrl: './add-team-dialog.component.css'
})
export class AddTeamDialogComponent implements OnInit {

  teamForm: FormGroup;
  matcher = new MyErrorStateMatcher();
  remainingUsers: any[];
  contract: Contract;
  isLoading: boolean = false;
  newReviewer: Reviewer = new Reviewer();
  newApprover: Approver = new Approver();
  userFullName: string;

  constructor(@Inject(MAT_DIALOG_DATA) public data: any, private dialogRef: MatDialogRef<AddTeamDialogComponent>, public fb: FormBuilder, private contractService: ContractService, private toast: ToastrService, private userService: UserService) {

    this.teamForm = this.fb.group({
      userInfo: [null, Validators.required],
      sequenceNo: [null, Validators.required]
    });

    if (this.userService.loggedinUser.middleName)
      this.userFullName = this.userService.loggedinUser.firstName + " " + this.userService.loggedinUser.middleName + " " + this.userService.loggedinUser.lastName;
    else
      this.userFullName = this.userService.loggedinUser.firstName + " " + this.userService.loggedinUser.lastName;

  }

  async ngOnInit() {
    await this.contractService.refreshContract(parseInt(this.data.contractId)).then((res: Contract) => {
      this.contract = res;
    });
    this.fetchAllUsers();
  }

  async fetchAllUsers() {
    try {
      if (this.data.mode == 2) {
        await this.contractService.getAllAvailableApprovers(this.data.contractId, this.contract.createdBy).then((res: Array<any>) => {
          this.remainingUsers = res;
        })
      } else {
        await this.contractService.getAllAvailableReviewers(this.data.contractId, this.contract.createdBy).then((res: Array<any>) => {
          this.remainingUsers = res;
        })
      }
    } catch {
      this.toast.error("Something went wrong! Please try again later.", "");
    }
  }

  async addTeam() {
    if (this.teamForm.valid) {
      this.isLoading = true;
     
      try {
        if (this.data.mode == 2) {
          const approver = this.teamForm.value;
          this.newApprover.contractId = this.data.contractId;
          this.newApprover.userInfo = approver.userInfo;
          this.newApprover.approverId = approver.userInfo.userId;
          this.newApprover.sequenceNo = approver.sequenceNo ?? 0;
          this.newApprover.status = 0;
          this.newApprover.createdBy = this.userFullName;
          this.newApprover.updatedBy = this.userFullName;
          await this.contractService.addApproverToContract(this.newApprover).then(() => { })
        } else {
          const reviewer = this.teamForm.value;
          this.newReviewer.contractId = this.data.contractId;
          this.newReviewer.userInfo = reviewer.userInfo;
          this.newReviewer.reviewerId = reviewer.userInfo.userId;
          this.newReviewer.sequenceNo = reviewer.sequenceNo ?? 0;
          this.newReviewer.status = 0;
          this.newReviewer.createdBy = this.userFullName;
          this.newReviewer.updatedBy = this.userFullName;
          await this.contractService.addReviewerToContract(this.newReviewer).then(() => { })
        }
          this.data.refresh();
          this.teamForm.reset();
          this.dialogRef.close();
          this.isLoading = false;
      } catch {
        this.toast.error("Something went wrong! Please try again later.", "");
      }
    }
  }
}